import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ServicesComponent } from './services/services.component';
import { CareersComponent } from './careers/careers.component';
// import { InnovationComponent } from './innovations/innovation.component';
// import { HomeComponent } from './home/home.component';
import { PracticeComponent } from './practice/practice.component';
// import { PartnersComponent } from './partners/partners.component';
// import { NewsComponent } from './news/news.component';

export const router: Routes = [
    //{path: '', redirectTo : 'home', pathMatch : 'full' },
    {path: '', loadChildren: () => import('./home/home.module').then(m => m.HomeModule)},
    {path: 'about', loadChildren: () => import('./about/about.module').then(m => m.AboutModule)},
    {path: 'careers', loadChildren: () => import('./careers/careers.module').then(m => m.CareersModule)},
    {path: 'innovation', loadChildren: () => import('./innovations/innovation.module').then(m => m.InnovationModule)},
    {
      path: 'services/:service', component: ServicesComponent
    },
    {
      path: 'practice/:area', component: PracticeComponent,
    }
  ];

export const routes: ModuleWithProviders<any> = RouterModule.forRoot(router, { enableTracing: true });
